import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Log } from 'ng2-logger/browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
    Log.setProductionMode();
}

// let isIE = /msie\s/i.test(window.navigator.userAgent);

const p = platformBrowserDynamic().bootstrapModule(AppModule);
p.then(() => { (window as any).appBootstrap && (window as any).appBootstrap(); });
// .catch(err => console.error(err));
